const atualizarChamadosManutencao = (state, chamadosManutencao) => {
    state.chamadosManutencao = chamadosManutencao;
}

const atualizarChamadoManutencao = (state, chamadoManutencao) => {
    state.chamadoManutencao = chamadoManutencao;
}

const updateChamadoManutencao = (state, chamadoManutencao) => {
    if (!chamadoManutencao || chamadoManutencao.id == null) return;

    const index = state.chamadosManutencao.findIndex(item => item.id === chamadoManutencao.id);
    if (index >= 0) {
        state.chamadosManutencao.splice(index, 1, JSON.parse(JSON.stringify(chamadoManutencao)));
    }
}

export default {
    atualizarChamadosManutencao,
    atualizarChamadoManutencao,
    updateChamadoManutencao
}
